



































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { Location } from "vue-router";

@Component
export default class DWInstrumentNavigation extends Vue {
  @Prop() activeTab: string;
  @Prop() navigate: (args: {tab: string}) => Location;
}
